export default function ProductLabel({ text }) {
  return (
    <label className="col-sm-4 col-form-label col-form-label-sm">{text}</label>
  );
}
